// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c43b93a05923aa989d2a","655":"66a6c10083076a4acad2"}[chunkId] + ".js";
};